class CnR {

    api_version = "2024-07";
    keyname = "subscriptions-2024-02";
    constructor(opts={}) {
        this.config = {...this.defaults(),...opts};
        this.errors=[];
        this.requires().forEach(field=>{
            if (!field in this.config) {
                this.errors.push(`Missing Required config field: ${field}`)
            }
        });
        if (this.errors.length>0) {
            throw new Error(this.errors.join("\n"));
        }
    }
    requires() {
        return []
    }
    defaults() {
        return {
            api_version:"2023-07",
            keyname:"subscriptions-2024-02"
        };
    }
    fetch(url,config) {
        if (this.config.fetch_function) {
            return pure_fetch(url,config)
        } else {
            return fetch(url,config)
        }
    }
    /* shopify cart functions */
    async getCart(url="/cart.js",extended=false,callback=()=>{}) {
        let cart = {};
        return this.fetch(url)
            .then(res=>(extended)?res.text():res.json());
    }
    async request(url) {
        return this.fetch(url).then(text=>response.text())
    }
    async updateCart(payload) {
        return this.fetch(`/cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
        }).then((response) => response.json());
    }
    async removeItemFromCart(key) {
        return this.changeCart({
            id:key,
            quantity:0
        })
    }
    async updateItemCount(key,quantity) {
        return this.changeCart({
            id:key,
            quantity:parseInt(quantity)
        })
    }
    async changeCart(payload) {
        return this.fetch(`/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
        }).then((response) => response.json());
    }
    async addToCart(payload) {
        let config = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }
        return this.fetch("/cart/add.js",config)
            .then((response) => response.json())
    }

    static setupDawnProductForm(form) {
        form.querySelector("button").addEventListener("click",event=>{
            event.preventDefault();
            event.stopPropagation();
            new CnR().addToDawnCart(form).then(response=>{

            });
        });
    }
    async addToDawnCart(form) {

        let cart = document.querySelector("cart-drawer");
        const formData = new FormData();
        formData.append('product-id',form.dataset.productId);
        formData.append("id",form.querySelector('[name="id"]').value)
        formData.append("quantity",1);
        try {
            formData.append("selling_plan",form.querySelector('[name="selling_plan"]').value);
        } catch(e) {}

        formData.append('sections',cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url',form.dataset.url);
        formData.append('form_type','product');

        return this.fetch("/cart/add",{
            method: 'POST',
            headers: {
                "Accept":"application/javascript",
                "X-Requested-With":"XMLHttpRequest"
            },
            body: formData,form
        })
            .then((response) => response.json())
            .then(json=>{


                if (json.status) {
                    CnRModal.show(json.description);
                } else {
                    cart.renderContents(json);
                    cart.classList.remove("is-empty")
                }
                return json;
            });
    }

    /* graphql functions */
    async graphql(query,params) {
        return fetch(`/api/${this.api_version}/graphql.json`,{
            method:"POST",
            headers:{
                "content-type":"application/json",
                "X-Shopify-Storefront-Access-Token":this.config.graphql_token
            },
            body:JSON.stringify({query:query,variables:params})
        })
            .then(response=>response.json())
    }
    graphql_sync(query,params) {
        let ajax = new XMLHttpRequest();
        ajax.headers = {
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
        }
        ajax.open("POST",/api/`${this.api_version}/graphql.json`,false)
        ajax.setRequestHeader("Content-Type", "application/json");
        ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
        ajax.send(JSON.stringify({query:query,params:params}));
        return JSON.parse(ajax.responseText);
    }
    gid2id(gid) {
        return parseInt(gid.split("/").pop())
    }
    collapse_query(object) {
        if (object==null) {
            return object;
        }
        switch(object.constructor.name) {
            case "Array":
                return object.map(item=>this.collapse_query(item));
                break;
            case "Object":
                let ret = {};
                Object.keys(object).forEach(key=>{
                    if (object[key]==null) {
                        ret[key] = null;
                        return;
                    }
                    if (object[key].reference) {
                        ret[key] = this.collapse_query(object[key].reference)
                        return;

                    }
                    if (object[key].references) {
                        let all = [];
                        object[key].references.nodes.forEach(ref=>{
                            let crv = {};
                            ref.fields.forEach(field=>{
                                crv[field.key]=this.collapse_query(field.value)
                            })
                            all.push(crv)
                        })
                        object[key] = all;

                    }
                    if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                        ret[key] = this.collapse_query(object[key].nodes);
                    } else {
                        ret[key] = this.collapse_query(object[key])
                    }
                });
                return ret
                break;
            default:
                if (object) {
                    return object;
                }

                break;
        }
    }
    css() {
        return '';
    }
    inject_css() {
        let css = this.css();
        if (css.length>0) {
            let style = document.createElement("style");
            style.id=this.constructor.name.toLowerCase();
            style.textContent = this.css();
            document.querySelector("head").appendChild(style);
        }

    }
}

class CnrStorefront extends CnR {
    requires() {
        return ["graphql_token"]
    }
}

class CnRSubscriptionsWidget extends CnR {
    defaults() {
        return {
            default_to_subscription:true,
            onetime_label:"One Time Purchase",
            subscription_label:"Autoship & save",
            delivery_label: "",
            injection_point:".cnr-subscription-widget",
            form_selector:"[data-product-form]",
            krc:true,
            selling_group_index:1,
            "id":"default-widget",
        };
    }
    constructor(options) {
        super(options);
        this.selling_plans = {}
        this.optionIndex = 0;
        this.root = document.querySelector(this.config.injection_point);
        this.load_product(this.config.product)
            .then(q=>{
                this.config.product = q.data.product;
                this.config.variants = q.data.product.variants.nodes.map(variant=>this.addVariant(variant));
                if (!this.config.variant_id) {
                    this.config.selected_variant = this.config.variants[0];
                } else {
                    this.config.selected_variant = this.config.variants.find(variant=>variant.id==this.config.variant_id)
                }
                if (q.data && q.data.product) {
                    if (q.data.product.sellingPlanGroups.nodes.length>0) {
                        this.selling_plans = this.parseSellingPlans(q);
                        if (!this.config.selling_plan_id) {
                            // Find first plan that matches the selected variant
                            const firstMatchingPlan = this.selling_plans.options.find(plan =>
                                plan.variantId === this.config.selected_variant.id
                            ) || this.selling_plans.options[0];

                            if (this.config.default_to_subscription) {
                                this.config.selling_plan = firstMatchingPlan;
                                this.config.last_selling_plan = this.config.selling_plan;
                            } else {
                                this.config.last_selling_plan = firstMatchingPlan;
                            }
                        } else {
                            this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==this.config.selling_plan_id);
                            this.config.last_selling_plan = this.config.selling_plan;
                        }
                    }
                }
                this.afterLoad();
                document.addEventListener("CartUpdated",event=>{
                    this.cart = event.detail;
                    this.render();
                });
                document.addEventListener("VariantChanged",event=>{
                    this.config.selected_variant = this.config.variants.find(variant=>variant.id==parseInt(event.detail))
                    this.render();
                });
                this.monitorForm();
                this.killReCharge();
                this.render();
            });
    }
    afterLoad() {}
    addVariant(variant) {
        return {
            id:this.gid2id(variant.id),
            price:parseFloat(variant.price.amount)
        }
    }
    parseSellingPlans(q) {
        return this.parseSellingPlansV2(q);
    }
    parseSellingPlansV1(q) {
        let group = q.data.product.sellingPlanGroups.nodes.pop();
        let variantMap = {}
        q.data.product.variants.nodes.forEach(variant=>{
            if (variant.sellingPlanAllocations!=null) {
                variant.sellingPlanAllocations.nodes.forEach(sellingPlan=>{
                    let id = this.gid2id(sellingPlan.id)
                    if (variantMap[id]!=null) {
                        variantMap[id].push(this.gid2id(variant.id))
                    } else {
                        variantMap[id].push[this.gid2id(variant.id)]
                    }
                })
            }
        })
        return {
            group_id:group.name,
            options:group.sellingPlans.nodes.map(selling_plan=>{
                return {
                    id:this.gid2id(selling_plan.id),
                    label:selling_plan.options[0].value,
                    discount:selling_plan.priceAdjustments[0].adjustmentValue.percent/100,
                };
            }),
            variantMap:this.mapVariants(q)
        };
    }
    
    parseSellingPlansV2(q) {
        let by_app = {};
        let sellingPlanToVariant = this.mapVariants(q); 
    
        q.data.product.sellingPlanGroups.nodes.forEach(group => {    
            if (!by_app[group.appName]) {
                by_app[group.appName] = [];
            }
    
            group.sellingPlans.nodes.forEach(sellingPlan => {
                const planId = this.gid2id(sellingPlan.id);
                const discount = sellingPlan.priceAdjustments[0].adjustmentValue.percent / 100;
    
                const variants = sellingPlanToVariant[planId] || [];
                variants.forEach(variant => {
                    by_app[group.appName].push({
                        id: planId,
                        label: group.name,
                        discount: discount,
                        variantId: variant.variantId,
                        price: variant.price 
                    });
                });
            });
        });
    
        return {
            group_id: this.config.subscription_label,
            options: this.config.use_app ? by_app[this.config.use_app] : Object.values(by_app).pop(),
            variantMap: sellingPlanToVariant
        };
    }    
    
    mapVariants(q) {
        let variantMap = {};
        q.data.product.variants.nodes.forEach(variant => {
            const variantId = this.gid2id(variant.id);
            const variantPrice = parseFloat(variant.price.amount);
            
            if (variant.sellingPlanAllocations && variant.sellingPlanAllocations.nodes.length > 0) {
                variant.sellingPlanAllocations.nodes.forEach(allocation => {
                    let sellingPlan = allocation.sellingPlan;
                    let sellingPlanId = this.gid2id(sellingPlan.id);
                    
                    if (variantMap[sellingPlanId]) {
                        variantMap[sellingPlanId].push({
                            variantId: variantId,
                            price: variantPrice
                        });
                    } else {
                        variantMap[sellingPlanId] = [{
                            variantId: variantId,
                            price: variantPrice
                        }];
                    }
                });
            } else {
                console.warn(`Variant ${variantId} has no selling plan allocations.`);
            }
        });
        return variantMap;
    }
    
    load_product(id) {
        return this.graphql(`
    query getProducts($id: ID!) {
      product(id:$id) {
        id
        variants(first:100) {
          nodes {
            id
            price {
              amount
            }
            sellingPlanAllocations(first:10) {
              nodes {
                sellingPlan {
                  id
                }
              }
            }
            ${this.additionalVariantQuery()}
          }
        }
        ${this.additionalProductQuery()}
        sellingPlanGroups(first: 10) {             
          nodes {
            appName
            name
            sellingPlans(first:250) {
              nodes {  
                recurringDeliveries
                id
                options {
                  value
                }
                description
                priceAdjustments {
                  adjustmentValue {
                    ... on SellingPlanPercentagePriceAdjustment {
                      percent: adjustmentPercentage
                    }
                    ... on SellingPlanFixedPriceAdjustment {
                      amount: price {
                        amount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
            {id:`gid://shopify/Product/${id}`}
        );
    }
    additionalVariantQuery() { return '';}
    additionalProductQuery() { return '';}
    regular_price(variant = null) {
        let price;
        if (this.config.selected_variant && typeof this.config.selected_variant.price !== 'undefined') {
            price = this.config.selected_variant.price;
        } else {
            price = window.currentlySelectedVariantPrice / 100;
        }
        return price;
    }
    
    display_regular_price() {
        return `$${this.regular_price().toFixed(2)}`
    }
    apply_discount(price,selling_plan) {
        return price*(1-((selling_plan)?selling_plan.discount:0));
    }
    discounted_price() {
        let selling_plan = this.config.selling_plan;
        console.log(selling_plan)
        if (!selling_plan) {
            selling_plan = this.config.last_selling_plan;
        }
        return this.apply_discount(this.config.selected_variant.price,selling_plan);
    }
    current_price() {
        if (this.config.selling_plan) {
            return this.discounted_price();
        } else {
            return this.regular_price();
        }
    }
    frequency_label() {
        return this.config.selling_plan?this.config.selling_plan.label:'';
    }
    display_discounted_price() {
        return this.discounted_price() % 1 === 0
            ? `$${this.discounted_price().toFixed(0)}`
            : `$${this.discounted_price().toFixed(2)}`;
    }
    subscription_label() {
        return `${this.config.subscription_label}`;
    }
    subscription_label_wrapper(discountPercentage) {
        return `<span class="rc_widget__option__discount">Save ${(discountPercentage*100).toFixed()}% ${window.productSettings?.inSaleCollection && window.discountSettings?.salePriceEnabled && (window.discountSettings?.saleScope == 'subscription' || window.discountSettings?.saleScope == 'all') ? `+ ${window.discountSettings?.saleDiscount}%` : ''}</span>`;
    }
    
    onetime_label() {
        return this.config.onetime_label;
    }
    killReCharge() {
        this.rci = window.setInterval(()=>{
            let recharge = document.querySelector(".recharge-subscription-widget");
            if (recharge) {
                recharge.parentElement.removeChild(recharge);

                window.clearInterval(this.rci)
            }
        },200)

    }
    getFormVariantField() {
        const form = document.querySelector(this.config.form_selector);
        return form ? form.querySelector('[name="id"]') : null;
    }
    monitorForm() {
        const form = document.querySelector(this.config.form_selector);
        if (!form) {
            console.warn('Recharge widget: Product form not found, retrying in 500ms');
            setTimeout(() => this.monitorForm(), 500);
            return;
        }

        const id = form.querySelector('[name="id"]');
        if (!id) {
            console.warn('Recharge widget: Variant ID input not found, retrying in 500ms');
            setTimeout(() => this.monitorForm(), 500);
            return;
        }

        const update = (variant_id)=>{
            this.config.selected_variant = this.config.variants.find(variant=>variant.id==variant_id)
            this.render();
        }
        switch(id.tagName) {
            case "SELECT":
                id.addEventListener("change",event=>{
                    console.error("select change")
                    update(parseInt(id.options[id.selectedIndex].value))
                })
                break;
            default:
                this.variant_observer = new MutationObserver((list,observer)=>{
                    let variant_id = parseInt(id.value);
                    this.config.selected_variant = this.config.variants.find(variant=>variant.id==variant_id)
                    this.render();
                });
                this.variant_observer.observe(id,{attributes:true,subtree:false,childList:true});
        }


    }
    onetime_label_extra() {
        return ``;
    }
    subscriptions_label_extra() {
        return `<ul class="subscription-widget-benefits"><li>Free US shipping + gifts</li><li>Edit, pause or cancel anytime</li><li>1:1 consultation with hair & scalp specialist</li></ul>`;
    }
    onetime_block_extra() {
        return ``;
    }
    subscriptions_block_extra() {
        return ``; }
    container_extra() {
        return '';
    }
    delivery_string() {
        return 'Delivers every'
    }
    format_label(label) {
        return label;
    }
    broadcastPlan(id) {
        document.dispatchEvent(new CustomEvent("cnr:subscriptions:planUpdated",{bubbles:true,detail:id}))
    }
    broadcastPrice() {
        document.dispatchEvent(new CustomEvent("cnr:subscriptions:priceUpdated",{bubbles:true,detail:this.current_price()}))
    }
    updateButtonPrice() {
        const fullPriceBox = document.querySelector('span.price-item.price-item--regular');
        const salePriceBox = document.querySelector('span.price-sale');

        if (fullPriceBox && salePriceBox) {
            let salePriceText = salePriceBox.innerText;
            let fullPriceText = fullPriceBox.innerText;
            salePriceText = salePriceText.replace(/[$,]/g, '');
            fullPriceText = fullPriceText.replace(/[$,]/g, '');
            const salePriceFloat = parseFloat(salePriceText);
            const fullPriceFloat = parseFloat(fullPriceText);
            const salePriceInt = Math.round(salePriceFloat);
            const fullPriceInt = Math.round(fullPriceFloat);

            if (salePriceInt === this.current_price()) {
                salePriceBox.classList.remove('d-none');
                fullPriceBox.classList.add('price-strike-through');
            }

            if (fullPriceInt === this.current_price()) {
                salePriceBox.classList.add('d-none');
                fullPriceBox.classList.remove('price-strike-through');
            }
        }
    }

    renderSellingPlanSelector(plans) {
        let selected_plan = this.config.selling_plan||this.config.last_selling_plan;
        return `
        <div class="options-selector ${plans.length>1?'multiple-options':''}">
          <select name="selling_plan_id" id="rc_shipping_interval_frequency" class="rc_select rc_select__frequency styled replaced">
            ${plans.map(plan=>{
            return `
                <option value="${plan.id}" ${(selected_plan.id==plan.id)?'selected':''}>
                  ${this.config.delivery_label} ${this.format_label(plan.label)}
                </option>`
        }).join('')}
          </select>
        </div>`;
    }
    planInput() {
        const form = document.querySelector(this.config.form_selector);
        return form ? form.querySelector('[name="selling_plan"]') : null;
    }

    render() {
        let selectedVariant = window.currentlySelectedVariant;

        // Fallback: get variant from form if window.currentlySelectedVariant is not set
        if (!selectedVariant) {
            const variantField = this.getFormVariantField();
            if (variantField) {
                selectedVariant = parseInt(variantField.value);
            }
        }

        let matchingPlans;

        if (this.selling_plans && this.selling_plans.options) {
            matchingPlans = this.selling_plans.options.filter(plan => plan.variantId === selectedVariant);
            // If no matching plans for this variant AND product has no variants, use all plans
            if (matchingPlans.length === 0 && this.config.variants.length === 1) {
                matchingPlans = this.selling_plans.options;
            }
        }

        this.root.innerHTML = `
      <div id="rc_container">
        <div id="rc_radio_options" role="radiogroup" aria-labelledby="Purchase options">
          <div class="rc_block rc_block__type rc_block__type__onetime ${!this.config.selling_plan?'rc_block__type--active':''}" >
          <div class="description">
            <input type="radio" id="rc_purchase_type_onetime" name="purchase_type" value="onetime" data-selling-plan="" class="rc_radio rc_radio__onetime" ${!this.config.selling_plan?'checked':''} data-purchase-type="onetime">
            <label for="rc_purchase_type_onetime" class="rc_label rc_label__onetime body2">
              <span class="rc_description"><span>${this.onetime_label()}</span>${window.productSettings?.inSaleCollection && window.discountSettings?.salePriceEnabled && (window.discountSettings?.saleScope == 'one' || window.discountSettings?.saleScope == 'all') ? `<span>
                <span style="text-decoration: line-through; color: #666;">$${this.regular_price()}</span>
                    <span style="color: #4d6245">
                        $${Number.isInteger(this.regular_price() * (1 - (window.discountSettings?.saleDiscount / 100)))
                            ? (this.regular_price() * (1 - (window.discountSettings?.saleDiscount / 100))).toString()
                            : (this.regular_price() * (1 - (window.discountSettings?.saleDiscount / 100))).toFixed(2)}
                    </span>
                </span>
                ` : `$${this.regular_price()}`}</span>
              <span id="rc_extra">${this.onetime_label_extra()}</span>
            </label>
            <div class="block-extra-content">${this.onetime_block_extra()}</div>
          </div>
        </div>
        <div class="rc_block rc_block__type rc_block__type__autodeliver ${this.config.selling_plan?'rc_block__type--active':''} ${this.selling_plans.options.length>0?'':'d-none'}" >
          <div class="description">
            <input type="radio" name="purchase_type" id="rc_purchase_type_autodeliver" value="autodeliver"  class="rc_radio rc_radio__autodeliver" ${this.config.selling_plan?'checked':''} data-purchase-type="autodeliver">
            <label for="rc_purchase_type_autodeliver" class="rc_label rc_label__autodeliver body2">
                <span class="rc_description">
                    <span>Subscribe + ${matchingPlans && matchingPlans[0] 
                        ? this.subscription_label_wrapper(matchingPlans[0]?.discount || 0.25) 
                        : this.subscription_label_wrapper(this.config.selling_plan?.discount || 0.15)}</span> 
                    <span class="discount-price">
                        <span class="regular-price">
                            ${matchingPlans && matchingPlans[0] ? '$' : ''}${
                                matchingPlans && matchingPlans[0]
                                    ? (
                                        window.productSettings?.inSaleCollection &&
                                        window.discountSettings?.salePriceEnabled &&
                                        (window.discountSettings?.saleScope === 'subscription' || window.discountSettings?.saleScope === 'all')
                                            ? Number.isInteger(
                                                parseFloat(matchingPlans[0]?.price || 0) *
                                                (1 - parseFloat(matchingPlans[0]?.discount || 0))
                                            )
                                                ? (parseFloat(matchingPlans[0]?.price || 0)).toString()
                                                : (parseFloat(matchingPlans[0]?.price || 0)).toFixed(2)
                                            : Number.isInteger(parseFloat(matchingPlans[0]?.price || 0))
                                                ? parseFloat(matchingPlans[0]?.price || 0).toString()
                                                : parseFloat(matchingPlans[0]?.price || 0).toFixed(2)
                                    )
                                    : (
                                        window.productSettings?.inSaleCollection &&
                                        window.discountSettings?.salePriceEnabled &&
                                        (window.discountSettings?.saleScope === 'subscription' || window.discountSettings?.saleScope === 'all')
                                            ? `$${this.regular_price()}`
                                            : `$${this.regular_price()}`
                                    )
                            }
                        </span>
                                                ${
                            matchingPlans && matchingPlans[0] 
                                ? `$${(
                                    window.productSettings?.inSaleCollection &&
                                    window.discountSettings?.salePriceEnabled &&
                                    (window.discountSettings?.saleScope === 'subscription' || window.discountSettings?.saleScope === 'all')
                                        ? Number.isInteger(
                                            parseFloat((matchingPlans[0]?.price || 0)) *
                                            (1 - parseFloat(matchingPlans[0]?.discount || 0)) *
                                            (1 - parseFloat(window.discountSettings?.saleDiscount || 0) / 100)
                                        )
                                            ? (parseFloat((matchingPlans[0]?.price || 0)) *
                                            (1 - parseFloat(matchingPlans[0]?.discount || 0)) *
                                            (1 - parseFloat(window.discountSettings?.saleDiscount || 0) / 100)).toString()
                                            : (parseFloat((matchingPlans[0]?.price || 0)) *
                                            (1 - parseFloat(matchingPlans[0]?.discount || 0)) *
                                            (1 - parseFloat(window.discountSettings?.saleDiscount || 0) / 100)).toFixed(2)
                                        : Number.isInteger(
                                            parseFloat((matchingPlans[0]?.price || 0)) *
                                            (1 - parseFloat(matchingPlans[0]?.discount || 0))
                                        )
                                            ? (parseFloat((matchingPlans[0]?.price || 0)) *
                                            (1 - parseFloat(matchingPlans[0]?.discount || 0))).toString()
                                            : (parseFloat((matchingPlans[0]?.price || 0)) *
                                            (1 - parseFloat(matchingPlans[0]?.discount || 0))).toFixed(2)
                                )}`
                                : `${
                                    window.productSettings?.inSaleCollection &&
                                    window.discountSettings?.salePriceEnabled &&
                                    (window.discountSettings?.saleScope === 'subscription' || window.discountSettings?.saleScope === 'all')
                                        ? `$${
                                            Number.isInteger(
                                                parseFloat(this.display_discounted_price().replace('$', '')) *
                                                (1 - parseFloat(window.discountSettings?.saleDiscount || 0) / 100)
                                            )
                                                ? (parseFloat(this.display_discounted_price().replace('$', '')) *
                                                (1 - parseFloat(window.discountSettings?.saleDiscount || 0) / 100)).toString()
                                                : (parseFloat(this.display_discounted_price().replace('$', '')) *
                                                (1 - parseFloat(window.discountSettings?.saleDiscount || 0) / 100)).toFixed(2)
                                        }`
                                        : this.display_discounted_price()
                                }`
                            }
                    </span>
                </span>
                <span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver" aria-label="recurring price"></span>
                <span id="rc_extra">${this.subscriptions_label_extra()}</span>
              </label>
              <div class="block-extra-content">${this.subscriptions_block_extra()}</div>
            </div>
            <div id="rc_autodeliver_options" class="rc_block__type__options">
                ${this.renderSellingPlanSelector((matchingPlans && matchingPlans.length > 0) ? matchingPlans : this.selling_plans.options)}
            </div>
          </div>
          <div class="container-extra">${this.container_extra()}</div>
        </div>
          ${this.extraHTML()}
        </div>
    `;
        let plan_input = this.planInput();
        if (!plan_input) {window.clearInterval(this.id);
            const form = document.querySelector(this.config.form_selector);
            if (form) {
                plan_input = document.createElement("input");
                plan_input.type="hidden";
                plan_input.name="selling_plan";
                form.appendChild(plan_input);
            }
        }
        
        let initialPrice;
        if (this.config.selling_plan) {
            initialPrice = this.discounted_price(matchingPlans);
        } else {
            initialPrice = this.regular_price();
        }
        this.updateAtcContent(initialPrice);

        if (this.selling_plans && this.selling_plans.options) {
            let selectedPlan;
            if (!selectedVariant) {
                selectedPlan = this.config.selling_plan?.id;
            } else {
                selectedPlan = matchingPlans[0];
            }
            if (matchingPlans.length > 0 || selectedPlan) {
                if (plan_input) {
                    plan_input.value = selectedPlan.id ? selectedPlan.id : selectedPlan;
                    document.querySelectorAll('.rc_radio__onetime').forEach((radio) => {
                        radio.addEventListener('click', () => {
                            this.updateAtcContent(window.currentlySelectedVariantPrice / 100);
                        })
                    }
                    )

                    document.querySelectorAll('.rc_radio__autodeliver').forEach((radio) => {
                        radio.addEventListener('click', () => {
                            this.config.selling_plan = selectedPlan;
                            const newPrice = this.calculateCurrentPrice(plan_input.value);
                            this.updateAtcContent(newPrice)
                        })
                    })

                    this.broadcastPlan(selectedPlan.id ? selectedPlan.id : selectedPlan);
                    this.broadcastPrice();
                } else {
                    console.error("plan_input is not defined or accessible.");
                }
            } else {
                console.warn("No selling plan found for the selected variant:", selectedVariant);
            }
        } else {
            console.error("Selling plans data or selected variant is missing.");
        }

        this.setupEvents();

        // Force enable all options (override any v3 interference)
        const enableOptions = () => {
            const frequencySelect = this.root.querySelector("#rc_shipping_interval_frequency");
            if (frequencySelect) {
                Array.from(frequencySelect.options).forEach(option => {
                    option.disabled = false;
                    option.style.display = 'block';
                });
            }
        };

        // Run multiple times to fight against v3 code
        setTimeout(enableOptions, 50);
        setTimeout(enableOptions, 150);
        setTimeout(enableOptions, 300);
        setTimeout(enableOptions, 500);

        // Watch for changes and re-enable if something disables them
        const frequencySelect = this.root.querySelector("#rc_shipping_interval_frequency");
        if (frequencySelect && window.MutationObserver) {
            const observer = new MutationObserver(() => {
                enableOptions();
            });
            observer.observe(frequencySelect, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['disabled', 'style']
            });
        }
    }
    verifyVariant(value) {
        let variantField = this.getFormVariantField()
        let variantId = parseInt(variantField.value)

        let variantMapEntry = this.selling_plans.variantMap[parseInt(value)]
        if (variantMapEntry && variantMapEntry.id) {
            let variantMapped = variantMapEntry.id
            if (!variantMapped.includes(variantId)) {
                variantField.value = variantMapped[0]?.id
            }
        }

    }
    setupSelectorEvents() {
        const frequencySelect = this.root.querySelector("#rc_shipping_interval_frequency");
        if (!frequencySelect) {
            console.warn("Frequency selector not found");
            return;
        }

        frequencySelect.addEventListener("change",event=>{
            let value = event.target.options[event.target.selectedIndex].value;
            this.config.last_selling_plan = this.config.selling_plan;
            this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==parseInt(value));
            this.broadcastPlan(value)
            this.broadcastPrice()

            this.planInput().value = value;
            this.verifyVariant(value)

        })
    }
    setupEvents() {
        this.setupSelectorEvents();
        this.root.querySelectorAll('input[name="purchase_type"]').forEach(radio=>{
            radio.addEventListener("change",event=>{

                switch(radio.dataset.purchaseType) {
                    case "onetime":
                        this.config.last_selling_plan = this.config.selling_plan;
                        this.config.selling_plan = null;

                        this.planInput().value="";
                        break;
                    case "autodeliver":

                        if (this.config.last_selling_plan) {
                            this.config.selling_plan = this.config.last_selling_plan;
                        } else {
                            this.config.selling_plan = this.selling_plans.options[0];
                        }
                        this.planInput().value = this.config.selling_plan.id;
                        this.verifyVariant(this.planInput().value)
                        break;

                }
                this.broadcastPrice();
                this.updateButtonPrice();
                this.broadcastPlan(this.planInput().value)
                this.render();

            });
        })

    }

    extraHTML() {
        return '';
    }
}

class AreyGreySubscriptionWidget extends CnRSubscriptionsWidget {
    container_extra() {
        return ``;
    }
    format_label(label) {
        return super.format_label(label)
    }
    parseSellingPlans(q) {
        return this.parseSellingPlansV2(q);
    }

    discounted_price(matchingPlans) {
        let matchingPlanDiscount;
        if(matchingPlans) {
            matchingPlanDiscount = matchingPlans[0]?.discount;
        }
        let selling_plan = this.config.selling_plan;
        let provisional_price;

        if (!selling_plan) {
            selling_plan = this.config.last_selling_plan;
        }
    
        let price;
        if (this.config.selected_variant && typeof this.config.selected_variant.price !== 'undefined') {
            price = this.config.selected_variant.price;
        } else {
            price = window.currentlySelectedVariantPrice / 100;
        }
    
        let discount = 0;
        if (selling_plan && typeof selling_plan.discount !== 'undefined') {
            discount = selling_plan.discount;
        }
        if(matchingPlanDiscount) {
            provisional_price = price * (1 - matchingPlanDiscount);
        } else {
            provisional_price = price * (1 - discount);
        }
    
        return provisional_price;
    }
    
    extraHTML() {
        return `
     `
    }
    render() {
        super.render();
        let root = document.querySelector(this.config.injection_point);
        /* root.querySelector(".rc-subscription-details").addEventListener("mouseover",event=>{
          root.querySelector(".rc-tooltip").classList.add("active");
        });
        root.querySelector(".rc-subscription-details").addEventListener("mouseout",event=>{
          root.querySelector(".rc-tooltip").classList.remove("active");
        }); */
    }

    calculateCurrentPrice(selectedPlanId) {
        const discountSettings = window.discountSettings;
        const productSettings = window.productSettings;
        
        if (selectedPlanId) {
            const sellingPlan = this.selling_plans.options.find(plan => plan.id == selectedPlanId);
            
            if (sellingPlan) {
                const basePrice = sellingPlan.price || this.regular_price();
                let finalPrice = basePrice;

                if (sellingPlan.discount) {
                    finalPrice *= (1 - sellingPlan.discount);
                }

                if (productSettings?.inSaleCollection && discountSettings?.salePriceEnabled) {
                    if (discountSettings.saleScope === 'subscription' || discountSettings.saleScope === 'all') {
                        finalPrice *= (1 - (discountSettings.saleDiscount / 100));
                    }
                }

                return finalPrice;
            }
        }
        
        const basePrice = this.regular_price();
        if (productSettings?.inSaleCollection && discountSettings?.salePriceEnabled) {
            if (discountSettings.saleScope === 'one' || discountSettings.saleScope === 'all') {
                return basePrice * (1 - (discountSettings.saleDiscount / 100));
            }
        }
        return basePrice;
    }

    updateAtcContent(currentPrice) {
        const discountSettings = window.discountSettings;
        const productSettings = window.productSettings;
        const atcButton = document.querySelector('.product-form__submit');
        let selectedVariant = window.currentlySelectedVariant;
        let matchingPlans;

        if (this.selling_plans && this.selling_plans.options) {
            matchingPlans = this.selling_plans.options.filter(plan => plan.variantId === selectedVariant);
        }

        let basePrice = matchingPlans && matchingPlans[0] 
        ? Number.isInteger((matchingPlans[0]?.price || 0) * (1 - (matchingPlans[0]?.discount || 0)))
            ? ((matchingPlans[0]?.price || 0) * (1 - (matchingPlans[0]?.discount || 0))).toString()
            : ((matchingPlans[0]?.price || 0) * (1 - (matchingPlans[0]?.discount || 0))).toFixed(2)
        : this.regular_price();
        let noDiscountPrice = this.regular_price();
        let displayPrice = currentPrice;
        let priceDisplay;
        
        if (document.querySelector('.rc_block__type__onetime').classList.contains('rc_block__type--active')) {
            priceDisplay = `${productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && 
                (discountSettings?.saleScope == 'one' || discountSettings?.saleScope == 'all') 
                ? `<span style="text-decoration:line-through; color: #666;">$${noDiscountPrice}</span>&nbsp;$${
                    Number.isInteger(noDiscountPrice * (1 - (discountSettings?.saleDiscount / 100)))
                        ? (noDiscountPrice * (1 - (discountSettings?.saleDiscount / 100))).toString()
                        : (noDiscountPrice * (1 - (discountSettings?.saleDiscount / 100))).toFixed(2)
                }` 
                : `$${noDiscountPrice}`}`;
        } else {
            priceDisplay = `${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && 
                (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) 
                ? `<span style="text-decoration:line-through; color: #666;">$${noDiscountPrice}</span>&nbsp;$${
                    Number.isInteger(displayPrice * (1 - (discountSettings?.saleDiscount / 100)))
                        ? (displayPrice * (1 - (discountSettings?.saleDiscount / 100))).toString()
                        : (displayPrice * (1 - (discountSettings?.saleDiscount / 100))).toFixed(2)
                }` 
                : `<span style="text-decoration:line-through; color: #666;">$${noDiscountPrice}</span>&nbsp;$${
                    Number.isInteger(displayPrice)
                        ? displayPrice.toString()
                        : displayPrice.toFixed(2)
                }`}`;
        }

        atcButton.innerHTML = `
            <span>Add to cart</span>
            &nbsp;-&nbsp;
            <span class="price-item price-item--regular subscription-price">
                ${priceDisplay}
            </span>
            <div class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        `;
    }
}